import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import VueFullscreen from 'vue-fullscreen'


import en from './locales/en.json'
import sq from './locales/sq.json'
import it from './locales/it.json'
import de from './locales/de.json'
import es from './locales/es.json'
import tr from './locales/tr.json'
import gr from './locales/gr.json'
import fr from './locales/fr.json'
import ar from './locales/ar.json'
import ru from './locales/ru.json'
import App from './App.vue'
import router from './router'
import { installVercelInsights } from './vercelInsights'
import lazy from './directives/lazy'
import imgFallback from './directives/imgFallback'

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
const nav_lang_full = navigator.language || navigator.userLanguage || 'en'
const nav_lang = nav_lang_full.split('-')[0]
const saved = localStorage.getItem('lang')
const initialLocale = (saved || nav_lang).split('-')[0]
const app = createApp(App)
const i18n = createI18n({
    legacy: false,
    locale: initialLocale,
    fallbackLocale: 'en',
    messages: {
        en,
        sq,
        it,
        de,
        es,
        tr,
        gr,
        fr,
        ar,
        ru
    }
})

app.use(createPinia())
app.use(router)
installVercelInsights(router) // no-op off Vercel, see src/vercelInsights.js
app.use(i18n)
app.use(VueFullscreen)
app.directive('lazy', lazy)
app.directive('img-fallback', imgFallback)

app.mount('#app')
import { useAuthStore } from '@/stores/auth'
(async () => {
  const auth = useAuthStore()
  const url = new URL(window.location.href)
  const token = url.searchParams.get('token')

  if (token) {
    localStorage.setItem('token', token)
    // 2) fetch the user
    try {
      await auth.fetchUser()
    } catch (e) {
      console.warn('Auto-login fetchUser failed:', e)
      return router.push({ name: 'login' })
    }
    // 3) clean URL
    history.replaceState({}, '', url.origin + url.pathname)
    router.push({ name: 'home' })
  }
  else if (localStorage.getItem('token') && !auth.userLoaded) {
    try { await auth.fetchUser() } catch {}
  }
})()
